import PubSub from 'core/pubsub'
import vhCheck from 'vh-check'

function windowResize() {

	// Re-measure on every resize. Mobile browsers (Chrome on Android in
	// particular) collapse/expand the URL bar based on scroll, which
	// changes the visible viewport height. vh-check sets --vh-offset
	// based on the current state, but it was previously only called
	// once at init — so once the URL bar moved after load, every
	// `calc(100vh - var(--vh-offset))` rule was sized for the wrong
	// viewport and the bottom of scrolling content rendered behind the
	// URL bar (BGG thread 3683906: "Mobile Scroll Window Cut Off on
	// Bottom of Window").
	vhCheck()

	var height = window.innerHeight
	var width = window.innerWidth

	window.sizeData = {
		menuIndentContent: (window.sizeData) ? window.sizeData.menuIndentContent : 0,
		width: width,
		height: height,
		scrollY: 0,
		is: {
			menu: (window.sizeData) ? window.sizeData.menu : false,
			smallmobile: width < 600,
			mobile: width < 1024,
			smalldesktop: width >= 1024 && width < 1340,
			desktop: width >= 1340
		}
	}

	PubSub.$emit('window.resize', window.sizeData)

}

PubSub.$on('window.initiated', function() {

	windowResize()

})

var indentCount = 0

function openIndent() {

	return

	/*indentCount++

	if (window.sizeData.width < 768) {

		window.sizeData.menuIndentContent = '0'

	} else {

		window.sizeData.menuIndentContent = '-320px'
	}

	PubSub.$emit('window.resize', window.sizeData)*/

}

function closeIndent() {

	if (indentCount) indentCount--

	if (indentCount === 0) {

		window.sizeData.menuIndentContent = 0

		PubSub.$emit('window.resize', window.sizeData)
		
	}

}

function contentScroll(e) {

	window.sizeData.scrollY = e

}

function openMenu() {

	if (window.sizeData.width < 768) {

		window.sizeData.menuIndentContent = '100%'

	} else {
	
		window.sizeData.menuIndentContent = '384px'

	}

}

function closeMenu() {

	window.sizeData.menuIndentContent = 0

}

PubSub.$on('panel.opened', openIndent)
//PubSub.$on('panel.closed', closeIndent)

PubSub.$on('close.modal', closeIndent)

PubSub.$on('menu.open', openMenu)
PubSub.$on('menu.close', closeMenu)
PubSub.$on('content.scroll', contentScroll)

window.addEventListener('resize', windowResize)

// Mobile browsers don't always fire `resize` on URL-bar collapse/expand
// — but `visualViewport` events do. Listen there too so --vh-offset
// stays fresh as the visible viewport shifts.
if (window.visualViewport) {
	window.visualViewport.addEventListener('resize', windowResize)
}

export default {

	data: function() {
		
		return {
			window: {
				menuIndentContent: 0,
				width: 0,
				height: 0,
				is: {
					menu: false,
					mobile: false,
					tablet: false,
					desktop: false
				}
			}
		}

	},

	created: function() {

		this.window = window.sizeData

		PubSub.$on('window.resize', this.onWindowResize.bind(this))

	},

	beforeDestroy: function() {

		PubSub.$off('window.resize', this.onWindowResize.bind(this))

	},

	methods: {

		onWindowResize: function(data) {

			this.window = data

		}

	}

}